import allModules from '../modules';

const moduleFactories = import.meta.glob('../modules/**/*.module.js');

export default async function loadModules(router) {
    const modules = await Promise.all(
        allModules.map((modulePath) => {
            const factory = moduleFactories[`../modules/${modulePath}.js`];

            if (!factory) {
                console.warn(`Module not found: ${modulePath}`);

                return null;
            }

            return factory();
        })
    );

    modules
        .filter(Boolean)
        .map((mod) => mod.default)
        .forEach(({ routes }) => {
            routes?.items?.forEach((route) => router.addRoute(route));
        });
}
